<template>
    <Dialog :open="open" :title="$t('circles.inviteUserToApp')" @close="$emit('close')">
        <v-form ref="form" v-model="validMail" @submit.prevent="sendInvitation">
            <v-row>
                <v-col cols="12">
                    <v-text-field
                            v-model="emailInvitation"
                            :rules="[$validations.required, $validations.email]"
                            required>
                        <template v-slot:label>
                            {{ $t('authentication.email') }}<sup>*</sup>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right">
                    <v-btn
                            :disabled="!validMail"
                            :loading="loading"
                            class=" py-6 accentText--text shadow-inverse"
                            color="accent"
                            depressed
                            @click="sendInvitation">
                        {{ $t('save') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";

export default {
  name: "InviteDialog",
  components: {Dialog},
  props: {
    open: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      validMail: false,
      loading: false,
      emailInvitation: '',
    };
  },
  computed: {
    organizationId() {
      return this.$store.getters.getOrganizationId;
    }
  },
  methods: {
    sendInvitation() {
      this.$refs.form.validate();
      if (!this.validMail || this.loading) {
        return;
      }
      this.loading = true;
      const url = this.$store.getters.invitation(this.organizationId);
      this.axios.post(url, this.emailInvitation).then(() => {
        this.$emit('close');
        this.$emit('invited');
        this.emailInvitation = '';
        this.$refs.form.reset();
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.invitationSentSuccessful'),
        });
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>

</style>